export default __webpack_public_path__ + "static/casecard5-9f5535ae55f202fbfdb88b2fd6bbee73.jpg";